// F1 CoreUI StartUp
import { api, auth, idle, Custom } from './service'
import * as _ from 'lodash'
import * as moment from 'moment-timezone'
import * as forge from 'node-forge'
import Toastr from 'vue-toastr'
import Filters from '@/f1/filter'
import XLSX from 'xlsx'
import { saveAs } from 'file-saver';
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true // add this line
// import signalR from '@aspnet/signalr' //
const signalR = require('@aspnet/signalr') // not supporting ES6 modules

import Vue from 'vue'
// import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import VueNumber from 'vue-number-animation'

import router from '@/f1/router'
import App from '@/App'
// import '@fortawesome/fontawesome-free/js/all.js'

require('vue-toastr/src/vue-toastr.scss');
if(location.hostname != 'localhost' && location.hostname != '10.20.0.4' && location.protocol == 'http:') {
  window.location.href = `https://${location.host}`
}

(async () => {
  console.log('F1Security Secaas Console App. v1.0');
  // should before then Vue.use()
  router.beforeEach((to, from, next) => {
    console.log('[router]', `${from.path}`, from.params, ' to ', `${to.path}`, to.params);
    // 로그인 여부 확인
    if(!to.matched.some(opt => opt.meta.requiresAuth) || auth.isAuthenticated()) { next(); }
    else {
      console.log('[router]', 'authentication required.');
      next({ path: '/login', query: { redirect: to.fullPath } });
    }
  })
  Vue.use(VueNumber)
  Vue.use(Filters)
  Vue.use(BootstrapVue)
  Vue.use(VueClipboard)
  Vue.use(Toastr, {
    defaultTimeout: 3000,
    defaultProgressBar: false,
    // defaultProgressBarValue: 0,
    // defaultType: "error",
    // defaultPosition: "toast-bottom-left",
    // defaultCloseOnHover: false,
    // defaultStyle: { "background-color": "red" },
    // defaultClassNames: ["animated", "zoomInUp"]
  })
  // Vue.use(Translate)

  await auth.init();
  await Custom.Setting_Call();
  // const store = new Vuex.Store();

  /* eslint-disable no-new */
  let vue = new Vue({
    el: '#app',
    // store,
    router,
    template: '<App/>',
    components: { App },
    beforeCreate () {
    },
  });

  window['log'] = console.log; // 반드시 출력할 로그 함수
  if(location.hostname == 'localhost') {
    window['moment'] = moment;
    window['forge'] = forge;
    window['router'] = router;
    window['vue'] = vue;
    // window['vuex'] = Vuex;
    window['api'] = api;
    window['auth'] = auth;
    window['idle'] = idle;
    window['xlsx'] = XLSX;
    window['saveAs'] = saveAs;
    // window['tr'] = Translate;
    window['signalR'] = signalR;
  } else {
    window['_'] = _;
    window['_rc_'] = () => console.log; // 로그함수 백업
    console.log = () => {}; // 로깅 감추기
  }
})();
